import React from 'react'
import { Box, Paper, Typography, Button, Chip } from '@mui/material'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { useNavigate, useLocation } from 'react-router-dom'

const scrollToPlans = () => {
  const el = document.getElementById('billing-plans')
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

interface ExpiredSubscriptionBannerProps {
  sx?: object
}

export const ExpiredSubscriptionBanner: React.FC<ExpiredSubscriptionBannerProps> = ({ sx }) => {
  const navigate = useNavigate()
  const location = useLocation()

  const handleViewPlans = () => {
    if (location.pathname === '/billing') {
      // Already on billing — just smooth scroll
      scrollToPlans()
    } else {
      // Navigate to billing then scroll after page renders
      navigate('/billing')
      setTimeout(scrollToPlans, 400)
    }
  }

  return (
    <Paper
      elevation={0}
      sx={{
        mb: 3,
        py: 1.5,
        px: { xs: 2, sm: 2.5 },
        borderRadius: 2.5,
        border: '1px solid',
        borderColor: (theme) =>
          theme.palette.mode === 'dark' ? 'rgba(239, 68, 68, 0.3)' : '#fee2e2',
        backgroundColor: (theme) =>
          theme.palette.mode === 'dark' ? 'rgba(69, 10, 10, 0.4)' : '#fef2f2',
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'flex-start', sm: 'center' },
        justifyContent: 'space-between',
        gap: 1.5,
        ...sx,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
        <Chip
          label="NO ACTIVE SUBSCRIPTION"
          size="small"
          sx={{
            fontWeight: 800,
            fontSize: '0.75rem',
            letterSpacing: '0.5px',
            bgcolor: '#dc2626',
            color: '#ffffff',
            height: 24,
            borderRadius: 1,
          }}
        />
        <Typography
          variant="body2"
          sx={{
            color: (theme) => (theme.palette.mode === 'dark' ? '#fecaca' : '#991b1b'),
            fontSize: '0.875rem',
            lineHeight: 1.4,
          }}
        >
          Select a plan to activate full features and services for your business.
        </Typography>
      </Box>

      <Button
        variant="contained"
        size="small"
        onClick={handleViewPlans}
        endIcon={<ArrowForwardIcon sx={{ fontSize: '15px !important' }} />}
        disableElevation
        sx={{
          fontWeight: 800,
          fontSize: '0.8125rem',
          textTransform: 'none',
          borderRadius: 2.25,
          px: 2.25,
          py: 0.75,
          flexShrink: 0,
          alignSelf: { xs: 'stretch', sm: 'center' },
          bgcolor: '#3b82f6',
          color: '#ffffff',
          boxShadow: '0 2px 6px rgba(59, 130, 246, 0.25)',
          '&:hover': {
            bgcolor: '#2563eb',
            boxShadow: '0 4px 12px rgba(59, 130, 246, 0.35)',
          },
        }}
      >
        View Plans
      </Button>
    </Paper>
  )
}

export default ExpiredSubscriptionBanner
